import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Injector } from '@angular/core';

export class ModalUtils {
  public static confirmationModalOptions(injector?: Injector): NgbModalOptions {
    return ModalUtils.mediumStatic(injector);
  }

  public static defaultModalOptions(injector?: Injector): NgbModalOptions {
    return ModalUtils.mediumStatic(injector);
  }

  public static defaultLargeModalOptions(injector?: Injector): NgbModalOptions {
    return ModalUtils.largeStatic(injector);
  }

  public static defaultExtraLargeModalOptions(injector?: Injector): NgbModalOptions {
    return ModalUtils.extraLargeStatic(injector);
  }

  static reorderModalOptions(injector?: Injector): NgbModalOptions {
    return this.mediumStatic(injector);
  }

  public static ignoreEscapeModalOptions(injector?: Injector): NgbModalOptions {
    return {
      modalDialogClass: 'medium-modal',
      keyboard: false,
      backdrop: 'static',
      centered: true,
      injector
    };
  }

  // For modals the user must complete before continuing. beforeDismiss vetoes every
  // dismissal, including the global NgbModal.dismissAll() fired on browser back/forward
  // navigation (app.component.ts), so the modal can only be closed programmatically.
  public static mandatoryModalOptions(injector?: Injector): NgbModalOptions {
    return {
      ...ModalUtils.ignoreEscapeModalOptions(injector),
      beforeDismiss: () => false
    };
  }

  private static mediumStatic(injector?: Injector): NgbModalOptions {
    return {
      modalDialogClass: 'medium-modal',
      backdrop: 'static',
      centered: true,
      injector
    };
  }

  private static largeStatic(injector?: Injector): NgbModalOptions {
    return {
      modalDialogClass: 'large-modal',
      backdrop: 'static',
      centered: true,
      injector
    };
  }

  private static extraLargeStatic(injector?: Injector): NgbModalOptions {
    return {
      modalDialogClass: 'extra-large-modal',
      backdrop: 'static',
      centered: true,
      injector
    };
  }
}
